module.exports = __webpack_public_path__ + "static/media/395SunsetAveNW_2018-06-11_158.0555845c.jpg";